import SettleInstallmentSingleModal from '@/components/_common/SettleInstallmentSingleModal';
import { SettleInstallmentSingleFormValues } from '@/components/_common/SettleInstallmentSingleModal/SettleInstallmentSingleForm/types';
import { SettleInstallmentSingleModalProps } from '@/components/_common/SettleInstallmentSingleModal/types';
import { useAccountReceivableSettleSingleInstallment } from '@/core/domain/financial/AccountReceivable/AccountReceivable.hooks';
import { handleInstallmentAlreadyEdited } from '@/core/domain/financial/AccountReceivable/AccountRecivable.errors';
import { DateTimeFormat } from '@/utils/moment';
import { AxiosError } from 'axios';

type Props = Omit<SettleInstallmentSingleModalProps, 'onOk'>;

const AccountReceivableSingleInstallmentModal: React.FC<Props> = (props) => {
  const settleSingleInstallment = useAccountReceivableSettleSingleInstallment();

  async function onOk(data: SettleInstallmentSingleFormValues) {
    try {
      if (typeof data.bankAccountId === 'number') {
        await settleSingleInstallment.mutateAsync({
          ...data,
          currentSituation: props.data?.currentSituation,
          bankAccountId: data.bankAccountId,
          payDate: data.payDate.format(DateTimeFormat),
        });
      }
    } catch (err: unknown) {
      const error = err as AxiosError;

      if (error.response?.data) {
        if (handleInstallmentAlreadyEdited(error)) {
          props.onCancel();
        }
      }
    }
  }

  return (
    <SettleInstallmentSingleModal
      {...props}
      onOk={onOk}
      confirmLoading={settleSingleInstallment.isLoading}
    />
  );
};

export default AccountReceivableSingleInstallmentModal;
